/**
 * Session Types
 * FEA-053: Type definitions for guided FMEA sessions
 * FEA-211: Extended with WorkSession and MeetingSession types
 */
import { SessionType, SessionStatus, SessionMode, MeetingType, WorkSessionStatus, MeetingSessionStatus, AttendeeRole, AgendaStatus, ActionPriority, ActionItemStatus, ChangeType, SessionEntityType, } from '../constants/enums';
export { SessionType, SessionStatus, SessionMode, MeetingType, WorkSessionStatus, MeetingSessionStatus, AttendeeRole, AgendaStatus, ActionPriority, ActionItemStatus, ChangeType, SessionEntityType, };
/**
 * Session step definitions by type (FEA-146: Simplified 3-phase)
 */
export const SESSION_STEPS = {
    // ========== KICKOFF (Early Project) ==========
    // Define scope, build initial system model, surface-level risk identification
    [SessionType.KICKOFF]: [
        { step: 1, name: 'Mission & Scope', page: 'mission' },
        { step: 2, name: 'Requirements', page: 'requirements' },
        { step: 3, name: 'System Functions', page: 'functions' },
        { step: 4, name: 'Block Diagram', page: 'components' },
        { step: 5, name: 'Quick Risk Scan', page: 'fm-workshop' },
        { step: 6, name: 'Summary Report', page: 'workshop-report' },
    ],
    // ========== DEEP DIVE (Engineering Phase) ==========
    // Detailed analysis through all workshops with full scoring
    [SessionType.DEEP_DIVE]: [
        { step: 1, name: 'Function Workshop', page: 'function-workshop' },
        { step: 2, name: 'FM Workshop', page: 'fm-workshop' },
        { step: 3, name: 'RC Workshop', page: 'causes-workshop' },
        { step: 4, name: 'Mitigations Workshop', page: 'mitigations-workshop' },
        { step: 5, name: 'Risk Overview', page: 'risk-overview' },
        { step: 6, name: 'Summary Report', page: 'workshop-report' },
    ],
    // ========== CLOSEOUT (End of Project) ==========
    // Verification, lessons learned, final documentation
    [SessionType.CLOSEOUT]: [
        { step: 1, name: 'Final Risk Review', page: 'risk-overview' },
        { step: 2, name: 'Verification Status', page: 'mitigations-workshop' },
        { step: 3, name: 'Lessons Learned', page: 'workshop-report' },
        { step: 4, name: 'Final Report', page: 'subsystem-risk-report' },
    ],
};
/**
 * Default agenda items by meeting type
 */
export const DEFAULT_AGENDA_BY_TYPE = {
    [MeetingType.DEFINE_MISSION]: [
        'Review project context and objectives',
        'Define system mission statement',
        'Identify key stakeholders',
        'Document scope boundaries',
    ],
    [MeetingType.DEFINE_REQUIREMENTS]: [
        'Review customer requirements',
        'Identify functional requirements',
        'Identify non-functional requirements',
        'Prioritize requirements',
    ],
    [MeetingType.MODEL_STRUCTURE]: [
        'Review system architecture',
        'Define block diagram structure',
        'Identify interfaces',
        'Assign functions to blocks',
    ],
    [MeetingType.ANALYZE_FM]: [
        'Review failure modes for focus area',
        'Assign severity scores',
        'Identify local effects',
        'Document system effects',
    ],
    [MeetingType.ANALYZE_RC]: [
        'Review failure modes for focus area',
        'Identify root causes using 5-Why',
        'Categorize causes using 5M framework',
        'Assign Occurrence scores',
        'Assign Detection scores',
        'Document decisions',
    ],
    [MeetingType.MITIGATE_WORKSHOP]: [
        'Review high-RPN items',
        'Brainstorm mitigation options',
        'Evaluate mitigation effectiveness',
        'Assign mitigations to owners',
    ],
    [MeetingType.MITIGATE_APPROVAL]: [
        'Review proposed mitigations',
        'Approve/reject mitigations',
        'Assign implementation responsibility',
        'Set implementation deadlines',
    ],
    [MeetingType.IMPLEMENT_REVIEW]: [
        'Review implementation status',
        'Verify work package completion',
        'Address blockers',
        'Update implementation timeline',
    ],
    [MeetingType.VERIFY_COMMISSION]: [
        'Review commissioning plan',
        'Verify test results',
        'Document issues',
        'Approve commissioning items',
    ],
    [MeetingType.VERIFY_CLOSEOUT]: [
        'Final risk review',
        'Document lessons learned',
        'Archive project data',
        'Generate final report',
    ],
    [MeetingType.GENERAL]: [
        'Review agenda',
        'Discussion items',
        'Action items',
        'Next steps',
    ],
    [MeetingType.AD_HOC]: [
        'Define meeting objective',
        'Discussion',
        'Decisions and actions',
    ],
};
//# sourceMappingURL=session.types.js.map